<template>
  <row :class="[baseCss]">
    <slot />
  </row>
</template>
<script>
import methods from '../../mixins/methods'

export default {
  name: 'TimelineItem',
  mixins: [
    methods
  ],
  data () {
    return {
      baseCss: this.componentBaseCss('timeline-item', [])
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/bcq-ui/components/timeline-item/timeline-item.vue